const routes = [
    {
        path: "/institutional/withdrawal/request/form",
        component: () => import("../pages/RequestForm"),
        meta: {
            isAuthenticated: true,
        },
    },
];

export default routes;
